import { FieldValues, useController } from "react-hook-form";
import { ZodDate, ZodNullable } from "zod";

import {
    DatePickerInput,
    DatePickerInputBaseProps,
} from "../fields/datePickerInput";

import { BaseRHFWidgetProps } from "./types";

type ValueType = Date | null;

export interface RHFDatePickerInputProps<TFieldsValues extends FieldValues>
    extends
        BaseRHFWidgetProps<TFieldsValues, ValueType>,
        DatePickerInputBaseProps {
    schema: ZodDate | ZodNullable<ZodDate>;
}

export function RHFDatePickerInput<TFieldsValues extends FieldValues>({
    control,
    name,
    label,
    disabled,
    disabledDate,
    autoFocus,
    schema,
    format,
    getPopupContainer,
    nodeAfter,
}: RHFDatePickerInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ control, name, disabled });
    const allowClear = schema.isNullable();

    return (
        <DatePickerInput
            nodeAfter={nodeAfter}
            label={label}
            error={fieldState.error?.message}
            value={field.value}
            disabled={field.disabled}
            disabledDate={disabledDate}
            allowClear={allowClear}
            onChange={field.onChange}
            autoFocus={autoFocus}
            format={format}
            getPopupContainer={getPopupContainer}
            fieldRef={field.ref}
        />
    );
}
